export default "__VITE_ASSET__BOO7Ks3T__"